/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.MyTeamChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './MyTeamChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.MyTeamChirpService#getPortalAggregations
 */
export const GET_PORTAL_AGGREGATIONS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_credentials_rpc_MyTeamChirpService_getPortalAggregations';
export const GET_PORTAL_AGGREGATIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_AGGREGATIONS_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPortalAggregationsRpc, {
      timeout: ctx.timeout,
      request: {}
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.MyTeamChirpService#getCertificationAggregationsByStatus
 */
export const GET_CERTIFICATION_AGGREGATIONS_BY_STATUS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_credentials_rpc_MyTeamChirpService_getCertificationAggregationsByStatus';
export const GET_CERTIFICATION_AGGREGATIONS_BY_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CERTIFICATION_AGGREGATIONS_BY_STATUS_QUERY_FIELD_NAME,
  args: ['categories', 'tools', 'teamIds', 'userIds', 'certificationNameFilter', 'certificationStatuses', 'sortOrder', 'sortField', 'preferredLanguage', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getCertificationAggregationsByStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.MyTeamChirpService#getTeamMemberCertificationAggregationsByStatus
 */
export const GET_TEAM_MEMBER_CERTIFICATION_AGGREGATIONS_BY_STATUS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_credentials_rpc_MyTeamChirpService_getTeamMemberCertificationAggregationsByStatus';
export const GET_TEAM_MEMBER_CERTIFICATION_AGGREGATIONS_BY_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TEAM_MEMBER_CERTIFICATION_AGGREGATIONS_BY_STATUS_QUERY_FIELD_NAME,
  args: ['categories', 'tools', 'teamIds', 'userIds', 'teamMemberNameFilter', 'certificationStatuses', 'sortOrder', 'sortField', 'excludeCurrentUser', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getTeamMemberCertificationAggregationsByStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.MyTeamChirpService#getTeamMembersCertificationsByStatus
 */
export const GET_TEAM_MEMBERS_CERTIFICATIONS_BY_STATUS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_credentials_rpc_MyTeamChirpService_getTeamMembersCertificationsByStatus';
export const GET_TEAM_MEMBERS_CERTIFICATIONS_BY_STATUS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_TEAM_MEMBERS_CERTIFICATIONS_BY_STATUS_QUERY_FIELD_NAME,
  args: ['certificationStatus', 'categories', 'tools', 'teamIds', 'userIds', 'teamMemberNameFilter', 'language', 'sortOrder', 'sortField', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getTeamMembersCertificationsByStatusRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.MyTeamChirpService#getIndividualCertificationOverview
 */
export const GET_INDIVIDUAL_CERTIFICATION_OVERVIEW_QUERY_FIELD_NAME = 'com_hubspot_learning_center_credentials_rpc_MyTeamChirpService_getIndividualCertificationOverview';
export const GET_INDIVIDUAL_CERTIFICATION_OVERVIEW_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INDIVIDUAL_CERTIFICATION_OVERVIEW_QUERY_FIELD_NAME,
  args: ['certificationId', 'pageSize', 'certificationStatus', 'teamIds', 'userIds', 'nameFilter', 'sortOrder', 'sortField', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getIndividualCertificationOverviewRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.MyTeamChirpService#getCertificate
 */
export const GET_CERTIFICATE_QUERY_FIELD_NAME = 'com_hubspot_learning_center_credentials_rpc_MyTeamChirpService_getCertificate';
export const GET_CERTIFICATE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CERTIFICATE_QUERY_FIELD_NAME,
  args: ['grantedCredentialId'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getCertificateRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});